import { TnError } from './TnError';

export interface TnErrorCartNotFoundData {
    // the cartId in the database.
    // TODO: rename to cartId, this was preserved in the original refactor and
    // I didn't want to get distract lookin up usages.
    cart: number;
}

/**
 * This exception is thrown anytime a family is queried, but we're unable to get it.
 */
export class TnErrorCartNotFoundError extends TnError<TnErrorCartNotFoundData> {
    public type = 'cartNotFound';
    constructor(cartId: number) {
        super(`Cart ${cartId} not found`, { cart: cartId });
    }
}
